import { useState } from "react";
import { faqs } from "../../../mocks/news";

const principles = [
  { icon: "ri-flashlight-line", title: "实时聚合", desc: "自动抓取全网公开热点并人工复核，新瓜出炉第一时间上架。" },
  { icon: "ri-shield-check-line", title: "多方核实", desc: "关键信息尽量交叉比对多个信源，还原事实本身，不夸大不站队。" },
  { icon: "ri-emotion-happy-line", title: "理性围观", desc: "引导网友理性讨论、文明发言，拒绝网暴与造谣，做健康瓜田。" },
  { icon: "ri-send-plane-line", title: "开放投稿", desc: "欢迎投稿刚发生的劲爆消息，核实通过后优先收录，共同更新榜单。" },
];

export default function AboutFaq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="about" className="mx-auto max-w-6xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <p className="flex items-center gap-2 text-sm font-semibold text-primary-600">
            <span className="h-px w-6 bg-primary-400" aria-hidden="true" />
            关于本站
          </p>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            吃瓜最新 · 今日新瓜热榜门户
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            「吃瓜最新」是一份面向中文网民的当天热点速递站。我们聚焦娱乐、社会、科技、民生与文体五大领域，
            把刚刚发生、正在发酵的新瓜集中呈现，帮你快速掌握今天最值得围观的话题与网友热议焦点。
          </p>
          <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-2">
            {principles.map((p) => (
              <div
                key={p.title}
                className="rounded-2xl border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-xl text-primary-600">
                  <i className={p.icon} aria-hidden="true" />
                </span>
                <p className="mt-3 font-heading text-base font-bold text-foreground-900">{p.title}</p>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
          <div className="mt-6 flex flex-wrap items-center gap-2 text-sm">
            <span className="text-foreground-500">想投稿或反馈？</span>
            <a
              href="mailto:editor@chigua-latest.example"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 font-medium text-white transition-colors hover:bg-primary-600"
            >
              <i className="ri-mail-send-line" aria-hidden="true" />
              editor@chigua-latest.example
            </a>
          </div>
        </div>

        <div className="lg:col-span-7">
          <h3 className="font-heading text-xl font-bold text-foreground-900 md:text-2xl">
            瓜友常见问题
          </h3>
          <div className="mt-5 divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={f.q}>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100/60 md:px-6"
                  >
                    <span className="flex items-center gap-3">
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-sm font-bold text-white ${
                          isOpen ? "bg-primary-500" : "bg-background-300 text-foreground-600"
                        }`}
                      >
                        Q{i + 1}
                      </span>
                      <span className="font-heading text-sm font-bold text-foreground-900 md:text-base">
                        {f.q}
                      </span>
                    </span>
                    <i
                      className={`ri-arrow-down-s-line shrink-0 text-xl text-foreground-500 transition-transform ${isOpen ? "rotate-180" : ""}`}
                      aria-hidden="true"
                    />
                  </button>
                  {isOpen && (
                    <p className="bg-background-50 px-5 pb-5 pl-[76px] text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-16">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
          <p className="mt-4 rounded-2xl border border-accent-200 bg-accent-50 px-5 py-4 text-sm text-accent-800">
            <i className="ri-information-line mr-1.5" aria-hidden="true" />
            温馨提示：站内内容均整理自公开信息，仅作信息聚合与讨论参考，不代表任何官方立场，请理性看待、文明围观。
          </p>
        </div>
      </div>
    </section>
  );
}